import { RemotefileService } from "@buf/brevdev_devplane.connectrpc_es/devplaneapi/v1/remotefile_connect";
import type { Client } from "@connectrpc/connect";
import { createConnectClient } from "../connect";

type ValidateDockerComposeRequest = {
  fileUrl?: string;
  yamlString?: string;
};

const client = createConnectClient(RemotefileService);

type DevplaneRemotefileClientOverride = Partial<Client<typeof RemotefileService>>;

export function createDevplaneRemotefile(
  override: DevplaneRemotefileClientOverride = {},
) {
  const c = { ...client, ...override };

  return {
    validateDockerCompose: async (request: ValidateDockerComposeRequest) =>
      c.getDockerCompose(request),
  };
}

export const DevplaneRemotefile = createDevplaneRemotefile();
